/** @jsx jsx */
import { jsx } from 'theme-ui'

const Grid = ({
  children,
  gridTemplateColumns = [
    'repeat(1, minmax(0, 1fr))',
    'repeat(1, minmax(0, 1fr))',
    'repeat(3, minmax(0, 1fr))'
  ],
  gap = [16, 24, 32]
}) => (
  <div
    sx={{
      display: 'grid',
      gridTemplateColumns,
      justifyContent: 'center',
      alignItems: 'center',
      rowGap: gap,
      columnGap: gap
    }}
  >
    {children}
  </div>
)

export default Grid
